import { DiffViewer } from "~/components/DiffViewer/DiffViewer";
interface DirtyStateDetailProps<Model> {
    model: Model;
    cleanModel: Model;
}
export function DirtyStateDetail<Model>({ cleanModel, model }: DirtyStateDetailProps<Model>) {
    const oldValue = JSON.stringify(cleanModel, null, 4);
    const newValue = JSON.stringify(model, null, 4);
    return <DiffViewer originalText={oldValue} updatedText={newValue} diffType="split" markEditsType="line"/>;
}
